import { GetRequestInterface } from "../../../interfaces/ActionReducer/GetMethod/GetRequest";

export const SHOW_PERMIT_LIST_VIEW = "SHOW_PERMIT_LIST_VIEW";
export const SHOW_PERMIT_BATCH_LIST_VIEW = "SHOW_PERMIT_BATCH_LIST_VIEW";
export const GET_DATA_FOR_PERMIT_FILTERS = "GET_DATA_FOR_FILTERS";
export const DATA_FOR_PERMIT_FILTERS_RECEIVED = "GET_DATA_FOR_FILTERS_RECEIVED";
export type Filters = Array<{ [prop: string]: any }>;

export interface showPermitsListViewAction {
    type: typeof SHOW_PERMIT_LIST_VIEW;
    payload: { showPermitsListView: boolean };
}
export interface showPermitsBatchListViewAction {
    type: typeof SHOW_PERMIT_BATCH_LIST_VIEW;
    payload: { showPermitsBatchListView: boolean };
}

export interface PermitsState {
    showPermitsListView?: boolean;
    showPermitsBatchListView?: boolean;
    selectedColumns: string[];
}
